import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { BeatLoader } from 'react-spinners';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { Image } from 'C4';
import { baseAppId, imgixUrl } from 'settings';

export default class ItemCard extends Component {
  constructor(props) {
    super(props);

    this.state = {
      loading: false,
      imageSet: false,
      imageURL: null,
      imageHeight: null,
    };
  }

  componentDidMount() {
    const { image } = this.props;
    this.parseImgixURL(image, false);
  }

  parseImgixURL(url, height) {
    const imageContainer = document.getElementById('imageContainer');
    const baseURL = `${imgixUrl}${baseAppId}${url.substring(url.indexOf(baseAppId) + baseAppId.toString().length)}`;
    const params = `?clip=fit&w=${imageContainer.clientWidth}&h=${height || 'auto'}`;
    this.setState({ imageURL: `${baseURL}${params}`, imageHeight: height || null });
  }

  render() {
    const {
      altImage,
      buttonIcon,
      buttonLink,
      buttonText,
      children,
      image,
      imageType,
      subtitle,
      title,
    } = this.props;

    const {
      loading, imageURL, imageHeight,
    } = this.state;

    return (
      <div className={`itemCard ${loading ? 'loading' : ''}`}>
        <BeatLoader
          color="#aaa"
          loading={loading}
        />
        {(imageURL && !imageHeight) && <img src={imageURL} alt="hidden" onLoad={e => this.parseImgixURL(image, e.target.height)} />}
        <div className={`itemCard--container ${loading ? 'loading' : ''}`} style={{ opacity: loading ? 0 : 1 }}>
          <div className="textContainer">
            {title &&
              <h4>
                {buttonIcon && <FontAwesomeIcon icon={['fas', buttonIcon]} />}
                {title}
              </h4>
            }
            {subtitle && <h6>{subtitle}</h6>}
          </div>
          {image &&
          <div
            id="imageContainer"
            className={`imageContainer ${imageType === 'css' ? imageType : ''}`}
            style={imageType === 'css' && imageURL ? { height: imageHeight, backgroundImage: `url('${imageURL}')` } : {}}
          >
            {imageType === 'image' && (
              <Image
                src={image}
                alt={altImage}
                gradient
                // default={{ width: 0, height: 0 }}
                onLoad={() => { this.setState({ loading: false }); }}
              />
            )}
          </div>}
        </div>
      </div>
    );
  }
}

ItemCard.propTypes = {
  altImage: PropTypes.string,
  image: PropTypes.string,
  imageType: PropTypes.string,
  title: PropTypes.string,
  buttonIcon: PropTypes.string,
  children: PropTypes.node,
  buttonLink: PropTypes.string,
  buttonText: PropTypes.string,
  subtitle: PropTypes.string,
};

ItemCard.defaultProps = {
  altImage: '',
  image: '',
  imageType: 'image',
  subtitle: '',
  title: '',
  buttonIcon: '',
  children: '',
  buttonLink: '',
  buttonText: '',
};
